import React from "react";
import PropTypes from "prop-types";
import { useTheme, Box, Skeleton } from "@mui/material";
import { Item } from "./Item";
import DashboardCardHeader from "./DashboardCardHeader";

const CardDashboardChart = ({
  title,
  content,
  isLoading = false,
  height = 250,
  tooltipTitle,
  tooltipContent,
}) => {
  const theme = useTheme();

  return (
    <Item
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "auto",
        maxHeight: "500px",
        p: 2.5,
        margin: 0,
        bgcolor: theme.palette.background.default,
        border: `1px solid ${theme.palette.primary.border2}`,
        borderRadius: "12px",
        boxShadow: theme.shadows[2],
      }}
    >
      {/* Title at the top left */}
      {title === "" ? null : (
        <DashboardCardHeader
          title={title}
          tooltipTitle={tooltipTitle}
          tooltipContent={tooltipContent}
          titleVariant="h6"
          titleColor={theme.palette.text.primary}
          titleSx={{ alignSelf: "flex-start" }}
        />
      )}

      <Box
        sx={{
          py: title === "" ? "0" : ".5rem",
        }}
      />

      {/* Content taking the rest with no padding */}
      {isLoading ? (
        <Box sx={{ height: height, width: "100%" }}>
          <Skeleton
            variant="rectangular"
            height="100%"
            width="100%"
            animation="wave"
            sx={{
              borderRadius: "12px",
              backgroundColor: theme.palette.background.default,
            }}
          />
        </Box>
      ) : (
        <Box sx={{ height: height, width: "100%" }}>{content}</Box>
      )}
    </Item>
  );
};

CardDashboardChart.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  height: PropTypes.number,
  tooltipTitle: PropTypes.string,
  tooltipContent: PropTypes.string,
};

export default CardDashboardChart;
